import React from 'react';
import { FileTextIcon, ExternalLinkIcon } from 'lucide-react';
export function HighPowerSection() {
  return <div className="bg-gray-100 rounded-2xl p-8 md:p-12 text-center max-w-4xl mx-auto border border-gray-200 mb-20 shadow-inner" data-id="element-387">
      <h3 className="text-2xl font-bold text-[#002d4d] mb-4" data-id="element-388">
        <a href="https://www.peakedm.com/uploaded/files/Bodor%20Files/Why%20we%20need%20a%2010kw+%20fiber%20laser-2021.03.pdf?direct=1" target="_blank" rel="noopener noreferrer" className="hover:text-[#f5693d] transition-colors flex items-center justify-center gap-2" data-id="element-389">
          Why Do We Need A 10kW+ Fiber Laser?
          <ExternalLinkIcon className="w-5 h-5" data-id="element-390" />
        </a>
      </h3>
      <div className="text-gray-700 space-y-4 text-lg leading-relaxed" data-id="element-391">
        <p data-id="element-392">
          For laser cutting machines, the higher the power, the faster the speed
          and the higher the efficiency. It can help shorten delivery time
          resulting in higher profit margins for the company.
        </p>
        <p className="font-medium text-[#002d4d] bg-white/50 py-2 px-4 rounded-lg inline-block" data-id="element-393">
          In stainless steel cutting, the processing speed of 12,000W laser
          machine is 3.4 times that of 6kW.
        </p>
        <div className="pt-4" data-id="element-394">
          <a href="https://www.peakedm.com/uploaded/files/Bodor%20Files/Why%20we%20need%20a%2010kw+%20fiber%20laser-2021.03.pdf?direct=1" target="_blank" rel="noopener noreferrer" className="inline-flex items-center text-[#f5693d] font-bold hover:text-[#d45025] transition-colors" data-id="element-395">
            Read more here <FileTextIcon className="w-4 h-4 ml-2" data-id="element-396" />
          </a>
        </div>
      </div>
    </div>;
}